import React from 'react';
import ChallengeCard from './ChallengeCard';

const challenges = [
  {
    title: "Victory Royale Challenge",
    description: "Win a Battle Royale match with at least 5 eliminations",
    credits: 500,
    difficulty: "Hard",
    timeRemaining: "2 hours",
    progress: 60
  },
  {
    title: "Building Master",
    description: "Build 100 structures in a single match",
    credits: 300,
    difficulty: "Medium",
    timeRemaining: "4 hours",
    progress: 45
  },
  {
    title: "Chest Hunter",
    description: "Open 7 chests in different named locations",
    credits: 200,
    difficulty: "Easy",
    timeRemaining: "8 hours",
    progress: 85
  }
];

function ChallengeSection() {
  return (
    <section className="py-16 px-4" id="challenges">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-[#0dceda] to-white text-transparent bg-clip-text">
          Daily Challenges
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {challenges.map((challenge, index) => (
            <ChallengeCard key={index} {...challenge} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ChallengeSection;